import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { ITenderType } from '@nibtravel/shared/util/models';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { defaultUnderwriterState, IUnderwriterState } from '../models';
import { UnderwriterDataService } from '../underwriter.data-service';
import { UnderwriterAction } from './undewriter.action';

@State<IUnderwriterState>({
  name: 'underwriter',
  defaults: defaultUnderwriterState,
})
@Injectable()
export class UnderwriterState {
  @Action(UnderwriterAction.LoadSummary)
  loadSummary(ctx: StateContext<IUnderwriterState>) {
    return this.uwService
      .getUnderwriterSummary()
      .pipe(tap((uw) => ctx.patchState({ ...uw })));
  }

  @Action(UnderwriterAction.LoadTenderTypes)
  loadTenderTypes(
    ctx: StateContext<IUnderwriterState>,
    { contractId }: UnderwriterAction.LoadTenderTypes
  ): Observable<ITenderType[]> {
    return contractId
      ? this.uwService.getTenderTypes(contractId).pipe(
          tap((data) => ctx.setState(patch({ tenderTypeMap: { ...data } }))),
          map((tenderTypes) => tenderTypes[contractId])
        )
      : of([]);
  }

  @Action(UnderwriterAction.SetCurrentContractId)
  setCurrentContractId(
    ctx: StateContext<IUnderwriterState>,
    { planId }: UnderwriterAction.SetCurrentContractId
  ): void {
    const state = ctx.getState();
    const contractId = state.planToContractMap?.[planId];
    ctx.setState(patch({ currentContractId: contractId }));
    ctx.dispatch(new UnderwriterAction.LoadTenderTypes(contractId));
  }

  constructor(private uwService: UnderwriterDataService) {}
}
